/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		1: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + "." + "3e40a806a7" + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Point = function () {
  function Point(x, y) {
    _classCallCheck(this, Point);

    this.x = x;
    this.y = y;
  }

  _createClass(Point, [{
    key: "greaterThan",
    value: function greaterThan(point) {
      return this.y > point.y || this.x > point.x;
    }
  }, {
    key: "equals",
    value: function equals(point) {
      return this.y === point.y && this.x === point.x;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Point(this.x, this.y);
    }
  }]);

  return Point;
}();

exports.default = Point;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// TODO: just use ES6 class...
var AnimatedPolyline = function AnimatedPolyline() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  this.options = _extends({
    lineCap: 'round',
    strokeStyle: '#f1dbce',
    lineWidth: 4,
    animated: true,
    animateAmount: 4
  }, options);

  this.finished = false;
  this.segments = options.segments;
  this.ctx = options.ctx;
  this.callback = options.callback || function () {};
  this.moveCallback = options.moveCallback || function () {};

  // array index of beginning position of current segment
  this.currentSegmentIndex = 0;

  this.startSegment();
};

AnimatedPolyline.prototype.startSegment = function () {
  var idx = this.currentSegmentIndex;
  var segments = this.segments;

  // Finish if we've exhausted our line segments
  if (this.currentSegmentIndex >= segments.length - 1) {
    this.finish();
    return;
  }

  this.currentPoint = segments[idx];
  this.nextPoint = segments[idx + 1];

  this.xDirection = true;
  this.yDirection = true;

  if (this.nextPoint.x - this.currentPoint.x < 0) {
    this.xDirection = false;
  }
  if (this.nextPoint.y - this.currentPoint.y < 0) {
    this.yDirection = false;
  }
};

AnimatedPolyline.prototype.draw = function (animated) {
  if (typeof animated !== 'undefined') {
    this.options.animated = animated;
  }
  this.finished = false;
  this.loop();
};

AnimatedPolyline.prototype.loop = function (lastRender) {
  var _this = this;

  if (this.finished) {
    return;
  }

  if (typeof lastRender === 'undefined') {
    lastRender = new Date().getTime();
  }

  var delta = new Date().getTime() - lastRender;
  this.renderTick(delta);
  lastRender = new Date().getTime();

  // set up our next frame
  this.animRequest = window.requestAnimationFrame(function () {
    return _this.loop(lastRender);
  });
};

AnimatedPolyline.prototype.finish = function () {
  this.stopDrawing();
  this.callback();
};

AnimatedPolyline.prototype.stopDrawing = function () {
  this.finished = true;
  if (this.animRequest) {
    window.cancelAnimationFrame(this.animRequest);
    this.animRequest = null;
  }
};

/* Given an amount to move from the current position (unit = canvas coordinates),
 * return the new coordinates to move to.
 */
AnimatedPolyline.prototype.getNextPosition = function (moveAmount) {
  var pos = this.currentPoint.clone();
  var targetPos = this.nextPoint.clone();

  if (!this.options.animated) {
    return targetPos;
  }

  var yDiff = Math.abs(targetPos.y - pos.y);
  var xDiff = Math.abs(targetPos.x - pos.x);

  if (moveAmount > yDiff) {
    // amount we're about to move exceeds amount we need to
    pos.y = targetPos.y;
  } else if (this.yDirection && targetPos.y > pos.y) {
    pos.y += moveAmount;
  } else if (!this.yDirection && targetPos.y < pos.y) {
    pos.y -= moveAmount;
  }

  if (moveAmount > xDiff) {
    // amount we're about to move exceeds what we need to
    pos.x = targetPos.x;
  } else if (this.xDirection && targetPos.x > pos.x) {
    pos.x += moveAmount;
  } else if (!this.xDirection && targetPos.x < pos.x) {
    pos.x -= moveAmount;
  }
  return pos;
};

AnimatedPolyline.prototype.renderTick = function (delta) {
  if (this.finished) return;

  var options = this.options;
  var interval = 60 / 1000;
  var ctx = this.ctx;
  var targetPos = this.nextPoint;

  // `options.animateAmount`px / frame @ 60 target fps
  var moveAmount = delta * interval * options.animateAmount;

  var pos = this.currentPoint;

  if (!targetPos.equals(pos)) {
    ctx.save();
    ctx.beginPath();
    ctx.lineCap = options.lineCap;
    ctx.strokeStyle = options.strokeStyle;
    ctx.moveTo(pos.x, pos.y);

    pos = this.currentPoint = this.getNextPosition(moveAmount);

    // var radius = 75;
    // var startAngle = 1.1 * Math.PI;
    // var endAngle = 1.9 * Math.PI;
    // var counterClockwise = false;
    // context.arc(x, y, radius, startAngle, endAngle, counterClockwise);

    ctx.lineTo(pos.x, pos.y);
    ctx.lineWidth = options.lineWidth;
    ctx.stroke();
    ctx.restore();

    this.moveCallback({
      x: pos.x,
      y: pos.y,
      animated: options.animated
    });
  } else if (targetPos.equals(pos)) {
    this.currentSegmentIndex += 1;
    this.startSegment();
  }
};

exports.default = AnimatedPolyline;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransformPropertyName = undefined;
exports.$ = $;
exports.getRelPosition = getRelPosition;

var _fastMemoize = __webpack_require__(6);

var _fastMemoize2 = _interopRequireDefault(_fastMemoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var doc = document;
var body = doc.body;

function $(id) {
  return doc.getElementById(id);
}

/* 
 * Get position of `node` relative to a specified
 *      `ancestor`
 */
function getRelPosition(node, ancestor) {
  var top = 0;
  var left = 0;

  while (node) {
    if (node.tagName) {
      top = top + node.offsetTop;
      left = left + node.offsetLeft;
      node = node.offsetParent;
    } else {
      node = node.parentNode;
    }
    if (node === ancestor) {
      node = null;
    }
  }

  return [left, top];
};

/*
 * Get prefixed or un-prefixed name of "transform" property
 * in this browser.
 */
var getTransformPropertyName = exports.getTransformPropertyName = (0, _fastMemoize2.default)(function () {
  var prefixes = ['', 'webkit', 'moz', 'ms'];
  for (var i = 0, ilen = prefixes.length; i < ilen; i++) {
    var prefix = prefixes[i];
    var propertyName = prefix + (prefix ? 'T' : 't') + 'ransform';
    if (typeof body.style[propertyName] !== 'undefined') {
      return propertyName;
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debounce = __webpack_require__(3);

var _debounce2 = _interopRequireDefault(_debounce);

var _domUtil = __webpack_require__(2);

var _scrollNav = __webpack_require__(7);

var _scrollNav2 = _interopRequireDefault(_scrollNav);

var _animatedFavicon = __webpack_require__(10);

var _animatedFavicon2 = _interopRequireDefault(_animatedFavicon);

var _facebook = __webpack_require__(12);

var _facebook2 = _interopRequireDefault(_facebook);

var _ga = __webpack_require__(13);

var _ga2 = _interopRequireDefault(_ga);

__webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var doc = document;
var bod = doc.body;

function initialize() {
  var slice = Array.prototype.slice;
  var sections = slice.call(doc.getElementsByTagName('section')).concat(slice.call(doc.getElementsByClassName('project')));
  var nav = new _scrollNav2.default(sections);

  window.addEventListener('resize', (0, _debounce2.default)(nav.redrawConnectors, 500));

  nav.addHandler('comicSans', function (section) {
    section.className += ' comic-sans';
  }, function (section) {
    section.className = section.className.replace('comic-sans', '');
  });

  nav.addStyleChanges([{
    el: (0, _domUtil.$)('sidebar'),
    0: 'top:120px',
    200: 'top:10px'
  }, {
    el: (0, _domUtil.$)('title'),
    0: 'opacity:1; top:22px; transform:rotate(9deg)',
    200: 'opacity:0; top:500px; transform:rotate(130deg)'
  }]);

  document.getElementsByTagName('html')[0].classList.remove('loading');

  (0, _animatedFavicon2.default)();
  (0, _facebook2.default)();
  (0, _ga2.default)();
}

var annoyingMode = false;
var gifViewerMode = false;
var imageCredit = void 0;
var imageCreditText = void 0;
var expandLink = void 0;

// Wrap event handler to match exact element and not bubble
function eventHandlerFor(element, handler, otherElHandler) {
  return function (e) {
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    if (typeof e.cancelBubble !== 'undefined') {
      e.cancelBubble = true;
    }
    if (e.target !== element) {
      if (otherElHandler) {
        otherElHandler(e);
      }
      return;
    }
    handler(e);
  };
}

/* Make background go crazy for psychedelic unicorns on-hover */
function toggleAnnoyingMode(on) {
  if (!annoyingMode && on) {
    annoyingMode = true;
    bod.classList.add('annoying');
  } else if (!on && !gifViewerMode) {
    annoyingMode = false;
    bod.className = bod.classList.remove('annoying');
  }
}

function toggleGifViewer(on) {
  toggleAnnoyingMode(on);
  if (!gifViewerMode && on) {
    gifViewerMode = true;
    bod.classList.add('gif-mode');
  } else if (!on) {
    gifViewerMode = false;
    bod.classList.remove('gif-mode');
  }
}

bod.addEventListener('mouseover', eventHandlerFor(bod, function () {
  if (!annoyingMode) {
    annoyingMode = true;
    bod.className += ' annoying';
  }
}, function () {
  toggleAnnoyingMode(false);
}));

var giphyPromise = void 0;
function initializeGiphy() {
  if (giphyPromise) {
    return giphyPromise;
  }
  giphyPromise = new Promise(function (resolve) {
    __webpack_require__.e/* require.ensure */(0).then((function (require) {
      resolve(__webpack_require__( /* webpackChunkName: "giphy" */15));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }).then(function (Giphy) {
    return new Giphy.default('edf9d49ffe4c45ed881c35edd4b14151');
  }) // eslint-disable-line new-cap
  .catch(function (error) {
    return console.log('Failed to load Giphy JS SDK', error);
  });
  return giphyPromise;
}

bod.addEventListener('click', eventHandlerFor(bod, function () {
  initializeGiphy().then(function (g) {
    return g.randomGIF('abstract');
  }).then(function (o) {
    toggleAnnoyingMode(true);
    bod.style.backgroundImage = 'url(' + o.images.original.url + ')';

    if (!imageCredit) {
      imageCredit = doc.createElement('div');
      imageCredit.id = 'imageCredit';
      imageCredit.className = 'image-credit';

      expandLink = doc.createElement('a');
      expandLink.className = 'expand-link hidden';
      expandLink.innerHTML = '&rarr;';
      expandLink.addEventListener('click', function (e) {
        e.preventDefault();
        if (expandLink.expanded) {
          expandLink.expanded = false;
          toggleGifViewer(false);
        } else {
          expandLink.expanded = true;
          toggleGifViewer(true);
        }
        return false;
      });
      imageCredit.appendChild(expandLink);

      imageCreditText = doc.createElement('span');
      imageCredit.appendChild(imageCreditText);

      bod.appendChild(imageCredit);
      window.setTimeout(function () {
        expandLink.className = expandLink.className.replace('hidden', '');
      }, 0);
    }

    var creditURL = o.source_post_url || o.source;
    if (creditURL.indexOf('http') !== 0) {
      creditURL = o.url;
    }

    var text = '\n          GIF by:\n          <a href="' + creditURL + '" target="_blank">' + o.username + '</a><br>\n          Via <a href="' + o.url + '" target="_blank">Giphy</a>\n      ';
    imageCreditText.innerHTML = text;
  }).catch(function (error) {
    return console.error('Error retrieving GIF', error);
  });
}));

initialize();

/***/ }),
/* 6 */
/***/ (function(module, exports) {

//
// Main
//

function memoize (fn, options) {
  var cache = options && options.cache
    ? options.cache
    : cacheDefault

  var serializer = options && options.serializer
    ? options.serializer
    : serializerDefault

  var strategy = options && options.strategy
    ? options.strategy
    : strategyDefault

  return strategy(fn, {
    cache: cache,
    serializer: serializer
  })
}

//
// Strategy
//

function isPrimitive (value) {
  return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
}

function monadic (fn, cache, serializer, arg) {
  var cacheKey = isPrimitive(arg) ? arg : serializer(arg)

  var computedValue = cache.get(cacheKey)
  if (typeof computedValue === 'undefined') {
    computedValue = fn.call(this, arg)
    cache.set(cacheKey, computedValue)
  }

  return computedValue
}

function variadic (fn, cache, serializer) {
  var args = Array.prototype.slice.call(arguments, 3)
  var cacheKey = serializer(args)

  var computedValue = cache.get(cacheKey)
  if (typeof computedValue === 'undefined') {
    computedValue = fn.apply(this, args)
    cache.set(cacheKey, computedValue)
  }

  return computedValue
}

function assemble (fn, context, strategy, cache, serialize) {
  return strategy.bind(
    context,
    fn,
    cache,
    serialize
  )
}

function strategyDefault (fn, options) {
  var strategy = fn.length === 1 ? monadic : variadic

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

function strategyVariadic (fn, options) {
  var strategy = variadic

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

function strategyMonadic (fn, options) {
  var strategy = monadic

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

//
// Serializer
//

function serializerDefault () {
  return JSON.stringify(arguments)
}

//
// Cache
//

function ObjectWithoutPrototypeCache () {
  this.cache = Object.create(null)
}

ObjectWithoutPrototypeCache.prototype.has = function (key) {
  return (key in this.cache)
}

ObjectWithoutPrototypeCache.prototype.get = function (key) {
  return this.cache[key]
}

ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
  this.cache[key] = value
}

var cacheDefault = {
  create: function create () {
    return new ObjectWithoutPrototypeCache()
  }
}

//
// API
//

module.exports = memoize
module.exports.strategies = {
  variadic: strategyVariadic,
  monadic: strategyMonadic
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debounce = __webpack_require__(3);

var _debounce2 = _interopRequireDefault(_debounce);

var _domUtil = __webpack_require__(2);

var _connector = __webpack_require__(8);

var _connector2 = _interopRequireDefault(_connector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var doc = document;
var bod = doc.body;
var win = window;

var ACTIVE = 'active';
var ACTIVE_REGEX = new RegExp(ACTIVE + '\\w*');
var MARGIN = 20;

/**
 * Manages scroll-driven effects
 *
 * TODO: split out scroll-monitoring logic from business logic
 *  (Just use e.g. https://github.com/stutrek/scrollMonitor for scroll-monitoring logic)
 */

var ScrollNav = function () {
  function ScrollNav(sections) {
    var _this = this;

    _classCallCheck(this, ScrollNav);

    this.redrawConnectors = function () {
      _this.foreachSection(function (section) {
        var connector = section.connector;
        if (!connector) {
          return;
        }
        connector.clear();
        connector.draw();
      });
    };

    this.sections = sections;
    this.currentSection = undefined;
    this.activeConnector = undefined;

    this.sectionActivateHandlers = {};
    this.sectionDeactivateHandlers = {};

    this.foreachSection(function (section) {
      section.addEventListener('click', function () {
        return _this.activateSection(section);
      });
    });

    window.setTimeout(function () {
      if (!_this.currentSection && !bod.scrollTop) {
        _this.activateSection((0, _domUtil.$)('about'));
      }
    }, 1000);

    // Cache DOM positioning and size properties for sections
    var calculateSectionProperties = function calculateSectionProperties() {
      for (var i = 0, ilen = _this.sections.length; i < ilen; i++) {
        var section = _this.sections[i];
        var posTop = section.offsetTop;
        section.setAttribute('data-offset-top', posTop);
        section.setAttribute('data-client-height', section.clientHeight);
      }
    };

    window.addEventListener('resize', (0, _debounce2.default)(calculateSectionProperties), 60);
    calculateSectionProperties();

    window.addEventListener('scroll', (0, _debounce2.default)(function () {
      var position = _this.position();
      var height = _this.browserHeight();
      var activatePosition = position + height / 2.5;

      for (var i = 0, ilen = _this.sections.length; i < ilen; i++) {
        var section = _this.sections[i];
        var posTop = parseInt(section.getAttribute('data-offset-top'), 10);
        var posBottom = posTop + parseInt(section.getAttribute('data-client-height'), 10);

        if (activatePosition < posBottom && activatePosition > posTop) {
          if (_this.activateSection(section)) {
            break;
          }
        }
      }
    }, 90));
  }

  _createClass(ScrollNav, [{
    key: 'position',
    value: function position() {
      return win.pageYOffset || bod.scrollTop;
    }
  }, {
    key: 'browserHeight',
    value: function browserHeight() {
      return win.innerHeight || doc.documentElement.clientHeight || bod.clientHeight;
    }
  }, {
    key: 'foreachSection',
    value: function foreachSection(func) {
      for (var i = 0, ilen = this.sections.length; i < ilen; i++) {
        func(this.sections[i]);
      }
    }

    // Return the main figure for the specified section

  }, {
    key: 'getFigureForSection',
    value: function getFigureForSection(section) {
      var figure = section.getElementsByTagName('figure');
      if (!figure.length) return false;
      return figure[0];
    }

    // Get first child of the active section with the specified tag name

  }, {
    key: 'getChildByTagName',
    value: function getChildByTagName(tagName) {
      var els = this.currentSection.getElementsByTagName(tagName);
      if (!els.length) return false;
      return els[0];
    }
  }, {
    key: 'activateSection',
    value: function activateSection(section) {
      // let's consider this a success; the section is already current
      if (section === this.currentSection) return true;

      // skip if section wasn't found or is already active
      if (!section || ACTIVE_REGEX.test(section.className)) {
        return false;
      }

      var figure = this.getFigureForSection(section);
      if (!figure && !this.hasHandlerForSection(section)) return false;

      // don't listen on sections that contain project sub-sections (we listen to the sub-sections)
      if (section.tagName.toLowerCase() === 'section' && section.getElementsByClassName('project').length) {
        return false;
      }

      // Deactivate last section
      if (this.currentSection) {
        this.callSectionHandler(true);
      }

      this.currentSection = section;

      section.className = section.className.replace(ACTIVE, '');
      section.className += ' ' + ACTIVE;

      if (figure) {
        figure.style.top = this.position() + document.documentElement.clientHeight - figure.offsetHeight - MARGIN + 'px';
        this.drawConnector();
      }

      this.callSectionHandler();
      return true;
    }
  }, {
    key: 'addHandler',
    value: function addHandler(sectionId, activateHandler, deactivateHandler) {
      this.sectionActivateHandlers[sectionId] = activateHandler;
      this.sectionDeactivateHandlers[sectionId] = deactivateHandler;
    }
  }, {
    key: 'hasHandlerForSection',
    value: function hasHandlerForSection(section) {
      if (typeof this.sectionActivateHandlers[section.id] === 'function') {
        return true;
      }
      return false;
    }
  }, {
    key: 'callSectionHandler',
    value: function callSectionHandler(deactivate) {
      var section = this.currentSection;
      var id = section.id;
      var handlers = this.sectionActivateHandlers;
      if (deactivate) {
        handlers = this.sectionDeactivateHandlers;
      }
      if (typeof handlers[id] === 'function') {
        handlers[id].call(null, section);
      }
    }
  }, {
    key: 'getConnector',
    value: function getConnector(section) {
      var _this2 = this;

      var title = this.getChildByTagName('h3') || this.getChildByTagName('h2');
      var figure = this.getFigureForSection(section);
      var connector = section.connector;

      if (connector) {
        return connector;
      }

      connector = new _connector2.default({
        parentEl: (0, _domUtil.$)('content'),
        src: title,
        dest: figure,
        style: {
          marginRight: 50,
          marginLeft: 5
        }
      });

      connector.addListener('cleared', function () {
        if (!_this2.currentSection) return;
        _this2.currentSection.className = _this2.currentSection.className.replace('active', '');
      });

      section.connector = connector;
      return connector;
    }
  }, {
    key: 'drawConnector',
    value: function drawConnector() {
      this.activeConnector = this.getConnector(this.currentSection);
      this.activeConnector.draw();
    }
  }]);

  return ScrollNav;
}();

exports.default = ScrollNav;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _domUtil = __webpack_require__(2);

var _event_target = __webpack_require__(9);

var _event_target2 = _interopRequireDefault(_event_target);

var _point = __webpack_require__(0);

var _point2 = _interopRequireDefault(_point);

var _polyline = __webpack_require__(1);

var _polyline2 = _interopRequireDefault(_polyline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Connector draws a line between two DOM elements using <canvas>.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Usage:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  var c = new Connector(document.getElementById('mySource'),
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *                         document.getElementById('myTarget'));
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  c.draw();
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  TODO: support choice of source and target edges. For now, left and right edges are used.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var style = {
  'marginLeft': 5,
  'marginRight': 50
};

var Connector = function (_EventTarget) {
  _inherits(Connector, _EventTarget);

  function Connector(prefs) {
    _classCallCheck(this, Connector);

    var parentEl = prefs.parentEl;
    var src = prefs.src;
    var dest = prefs.dest;
    prefs.style = prefs.style || {};
    for (var option in prefs.style) {
      style[option] = prefs.style[option];
    }

    var _this = _possibleConstructorReturn(this, (Connector.__proto__ || Object.getPrototypeOf(Connector)).call(this));

    _this.src = src;
    _this.dest = dest;
    _this.parentEl = parentEl;
    return _this;
  }

  _createClass(Connector, [{
    key: 'fireMoveEvent',
    value: function fireMoveEvent(x, y) {
      // adjust from canvas-relative coordinates to div#content -relative coordinates
      this.fire({
        x: x + parseInt(this.canvas.style.left, 10),
        y: y + parseInt(this.canvas.style.top, 10),
        type: 'move'
      });
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.line = null;
      this.canvas.parentNode.removeChild(this.canvas);
      this.canvas = null;
      this.ctx = null;
    }
  }, {
    key: 'draw',
    value: function draw(animated) {
      var _this2 = this;

      if (typeof animated === 'undefined') {
        animated = true;
      }

      var src = this.src;
      var dest = this.dest;
      var parentEl = this.parentEl;

      var srcPosition = (0, _domUtil.getRelPosition)(src, parentEl);
      var destPosition = (0, _domUtil.getRelPosition)(dest, parentEl);

      var srcX = srcPosition[0] + src.offsetWidth + style.marginLeft;
      var srcY = srcPosition[1] + src.offsetHeight / 2;

      var destX = destPosition[0] + dest.offsetWidth / 2;
      var destY = destPosition[1] + dest.offsetHeight / 2;

      var top = Math.min(destY, srcY);
      var left = Math.min(destX, srcX);

      var MARGIN = 25;

      srcX -= left - MARGIN;
      destX -= left;
      srcY -= top - MARGIN;
      destY -= top;

      var canvas = this.canvas = document.createElement('canvas');
      canvas.height = Math.abs(destY - srcY) + MARGIN * 2;
      canvas.width = Math.abs(destX - srcX) + MARGIN * 2;
      canvas.style.position = 'absolute';
      canvas.style.top = top - MARGIN + 'px';
      canvas.style.left = left - MARGIN + 'px';
      parentEl.appendChild(canvas);
      this.ctx = canvas.getContext('2d');

      this.line = new _polyline2.default({
        segments: [new _point2.default(srcX, srcY), new _point2.default(srcX + 20, srcY), new _point2.default(destX, destY)],
        ctx: this.ctx,
        callback: function callback(o) {
          return _this2.fire('completed');
        },
        moveCallback: function moveCallback(o) {
          if (o.animated) {
            _this2.fireMoveEvent(o.x, o.y);
          }
        }
      });
      this.line.draw(animated);
    }
  }]);

  return Connector;
}(_event_target2.default);

exports.default = Connector;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

//Copyright (c) 2010 Nicholas C. Zakas. All rights reserved.
//MIT License

/*global define */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    "use strict";

    function EventTarget() {
        this._listeners = {};
    }

    EventTarget.prototype = {

        constructor: EventTarget,

        addListener: function addListener(type, listener) {
            if (typeof this._listeners[type] == "undefined") {
                this._listeners[type] = [];
            }

            this._listeners[type].push(listener);
        },

        fire: function fire(event) {
            if (typeof event == "string") {
                event = { type: event };
            }
            if (!event.target) {
                event.target = this;
            }

            if (!event.type) {
                //falsy
                throw new Error("Event object missing 'type' property.");
            }

            if (this._listeners[event.type] instanceof Array) {
                var listeners = this._listeners[event.type];
                for (var i = 0, len = listeners.length; i < len; i++) {
                    listeners[i].call(this, event);
                }
            }
        },

        removeListener: function removeListener(type, listener) {
            if (this._listeners[type] instanceof Array) {
                var listeners = this._listeners[type];
                for (var i = 0, len = listeners.length; i < len; i++) {
                    if (listeners[i] === listener) {
                        listeners.splice(i, 1);
                        break;
                    }
                }
            }
        }
    };

    return EventTarget;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = animatedFavicon;
var doc = document;
var canvas = doc.createElement('canvas');
var img = doc.createElement('img');

function animatedFavicon() {
  if (canvas.getContext && typeof canvas.toDataURL === 'function') {
    canvas.height = canvas.width = 16;
    var ctx = canvas.getContext('2d');
    img.onload = function () {
      var img = this;
      var position = canvas.height;
      var link = doc.getElementById('favicon');
      var newLink = void 0;

      var loop = function loop() {
        newLink = link.cloneNode(true);
        ctx.clearRect(0, 0, canvas.height, canvas.width);
        ctx.drawImage(img, 0, position);
        newLink.setAttribute('href', canvas.toDataURL());
        link.parentNode.replaceChild(newLink, link);
        link = newLink;
        if (position > 0) {
          position--;
          window.setTimeout(loop, 100);
        } else {
          position = canvas.height;
          window.setTimeout(loop, 10000);
        }
      };
      loop();
    };
    img.src = __webpack_require__(11);
  }
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "favicon.562r304p.png";

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadFacebookSDK;
/* global FB */

function loadFacebookSDK() {
  window.fbAsyncInit = function () {
    try {
      FB.init({
        async: true,
        xfbml: true,
        version: 'v2.8'
      });

      // Trigger some crazy styling after the user hits Like
      FB.Event.subscribe('edge.create', function () {
        document.body.classList.add('sickening');
      });
    } catch (e) {
      console.log('Error loading Facebook SDK', e);
    }
  };

  (function (d, s, id) {
    var js = void 0;
    var fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);js.id = id;
    js.src = 'https://connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk');
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
		value: true
});
exports.default = googleAnalyticsTag;
function googleAnalyticsTag() {
		/* eslint-disable */
		(function (i, s, o, g, r, a, m) {
				i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
						(i[r].q = i[r].q || []).push(arguments);
				}, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
		})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
		ga('create', 'UA-41489908-1', 'regenspan.com');
		ga('send', 'pageview');
		/* eslint-enable */
}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.3e40a806a7.js